import { getDoc, doc, collection } from "firebase/firestore";
import {
  firebase_auth,
  firestore_database,
} from "@src/utility_functions/database_operations/config/firebaseConfig";

export const fetchFirestoreUserObjectPrivate = async (firestoreID) => {
  let returnValue;
  try {
    const privateInfoDocumentReference = doc(
      collection(doc(firestore_database, "users", firestoreID), "privateInfo"),
      "privateInfo",
    );
    const privateInfoDocumentSnapshot = await getDoc(
      privateInfoDocumentReference,
    );
    const privateInfoDocumentData = privateInfoDocumentSnapshot.data();
    privateInfoDocumentData.emailVerified =
      firebase_auth.currentUser.emailVerified;
    returnValue = privateInfoDocumentData;
  } catch (error) {
    console.warn(error);
    returnValue = undefined;
  }
  return returnValue;
};
